import request from './request'

export function projectCostReport(params) {
  return request.get('/biz/report/project-cost', { params })
}

export function exportProjectCostReport(params) {
  return request.get('/biz/report/project-cost/export', { params, responseType: 'blob' })
}

export function projectCostMaterialDetail(params) {
  return request.get('/biz/report/project-cost/material-detail', { params })
}

export function projectCostLaborDetail(params) {
  return request.get('/biz/report/project-cost/labor-detail', { params })
}

export function materialSalesReport(params) {
  return request.get('/biz/report/material-sales', { params })
}

export function exportMaterialSalesReport(params) {
  return request.get('/biz/report/material-sales/export', { params, responseType: 'blob' })
}

export function materialSalesDetail(params) {
  return request.get('/biz/report/material-sales/detail', { params })
}

export function laborCostReport(params) {
  return request.get('/biz/report/labor-cost', { params })
}

export function exportLaborCostReport(params) {
  return request.get('/biz/report/labor-cost/export', { params, responseType: 'blob' })
}

export function laborCostDetail(params) {
  return request.get('/biz/report/labor-cost/detail', { params })
}

export function supplierSalesReport(params) {
  return request.get('/biz/report/supplier-sales', { params })
}

export function exportSupplierSalesReport(params) {
  return request.get('/biz/report/supplier-sales/export', { params, responseType: 'blob' })
}

export function supplierSalesDetail(params) {
  return request.get('/biz/report/supplier-sales/detail', { params })
}
